export default __webpack_public_path__ + "static/media/ahmed.14a939d2.jpeg";